<template>
  <div class="gap-18 height-max-content b-radius-12 pack_detail_container_2">
    <div class="d-flex-column justify-start content align-start gap-18">
      <h2 class="t-white font-family-2 bold-xxxxl">
        {{ getGamePack.short_title }}
      </h2>

      <ul class="perk_list" :class="[getGame.slug]">
        <li
          class="t-light regular-m font-family-2"
          v-for="perk in getGamePack.perks"
        >
          {{ perk.title }}
        </li>
      </ul>
      <p class="t-grey font-family-2 regular-l">
        {{ getGamePack.description }}
      </p>
    </div>

    <div class="image_container">
      <img
        :src="`/images/games/path-of-exile-2-boost/packs/${getGamePack.slug}.webp`"
        class="pack_image b-radius-9"
        alt="game_pack_image"
      />
    </div>
  </div>
</template>

<script setup>
const { getGamePack, getGame } = useGameStore();
</script>

<style lang="scss">
.pack_detail_container_2 {
  //   padding: 12px;
  padding: 24px;
  display: flex;
  border: 1px solid var(--stroke-dark);
  align-items: stretch;
  position: relative;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute;
    height: 100%;
    max-height: 175px;
    width: 50%;
    max-width: 175px;
    filter: blur(80px);
    opacity: 0.7;
    transition: all 0.25s ease-in;
    right: 0;
    transform: translate(-25%, 0%);
    z-index: 0;
    background-color: var(--path-of-exile);
  }
  .image_container {
    width: 100%;
    height: 100%;
    max-width: 250px;
    position: absolute;
    bottom: 0%;
    right: 0;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .pack_image {
      width: 100%;
      height: auto;
      object-fit: cover;
      object-position: center;
    }
  }

  .perk_list {
    width: 100%;
    list-style-type: none;
    padding: 0;
    list-style-type: none;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 9px;
    margin-top: 6px;
    flex-wrap: wrap;
    gap: 5px;
    li {
      margin-right: 16px;
      padding-left: 5px;
    }
    &.path-of-exile-2-boost {
      list-style-image: url("/images/games/path-of-exile-2-boost/star.svg");
    }
  }
  .content {
    max-width: 60%;
    // z-index: 1;
  }
  @media screen and (max-width: 768px) {
    .image_container,
    &::before {
      opacity: 0.25;
      display: none;
    }
    .content {
      max-width: 100%;
    }
  }
}
</style>
